import React, { useState } from "react";
import "./Signup.css";

import {
  FiBriefcase,
  FiCheck,
  FiEye,
  FiEyeOff,
  FiGift,
  FiGlobe,
  FiLink,
  FiLock,
  FiMail,
  FiPhone,
  FiUser,
} from "react-icons/fi";

import { useHistory } from "react-router-dom";

import API from "../../utils/apiCalling";
import { config } from "../../utils/apiUrl";

const logo = "/assets/img/logo.png";


const Signup = () => {

  const api = new API();

  const history = useHistory();


  /*
  |--------------------------------------------------------------------------
  | FORM
  |--------------------------------------------------------------------------
  */

  const [form, setForm] = useState({

    businessName: "",

    businessCode: "",

    businessMobile: "",

    businessEmail: "",

    subdomain: "",

    customDomain: "",

    ownerName: "",

    ownerMobile: "",

    ownerEmail: "",

    password: "",

    confirmPassword: "",

    referral: "",

  });


  /*
  |--------------------------------------------------------------------------
  | SUBDOMAIN MANUAL EDIT
  |--------------------------------------------------------------------------
  */

  const [
    subdomainManuallyEdited,
    setSubdomainManuallyEdited,
  ] = useState(false);


  /*
  |--------------------------------------------------------------------------
  | PASSWORD
  |--------------------------------------------------------------------------
  */

  const [
    showPassword,
    setShowPassword,
  ] = useState(false);


  const [
    showConfirmPassword,
    setShowConfirmPassword,
  ] = useState(false);


  /*
  |--------------------------------------------------------------------------
  | LOADING
  |--------------------------------------------------------------------------
  */

  const [
    loading,
    setLoading,
  ] = useState(false);


  /*
  |--------------------------------------------------------------------------
  | GENERATE SUBDOMAIN
  |--------------------------------------------------------------------------
  |
  | Example:
  |
  | ComKwik Computers
  |
  |        ↓
  |
  | comkwik-computers
  |
  |--------------------------------------------------------------------------
  */

  const generateSubdomain = (value) => {

    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/^-+|-+$/g, "")
      .slice(0, 50);

  };


  const generateBusinessCode = (value) => {

    return String(value || "")
      .trim()
      .toUpperCase()
      .replace(/[^A-Z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "")
      .slice(0, 50);

  };


  /*
  |--------------------------------------------------------------------------
  | FIELD CHANGE
  |--------------------------------------------------------------------------
  */

  const handleChange = (event) => {

    const {
      name,
      value,
    } = event.target;


    /*
    |--------------------------------------------------------------------------
    | MOBILE NUMBER
    |--------------------------------------------------------------------------
    */

    if (
      name === "businessMobile" ||
      name === "ownerMobile"
    ) {

      setForm((previous) => ({

        ...previous,

        [name]:
          value
            .replace(/\D/g, "")
            .slice(0, 10),

      }));

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | BUSINESS NAME
    |--------------------------------------------------------------------------
    |
    | Automatically generate subdomain from business name.
    |
    | If user manually changes the subdomain, we stop overwriting it.
    |
    |--------------------------------------------------------------------------
    */

    if (
      name === "businessName"
    ) {

      setForm((previous) => ({

        ...previous,

        businessName:
          value,

        businessCode:
          generateBusinessCode(value),

        subdomain:
          subdomainManuallyEdited
            ? previous.subdomain
            : generateSubdomain(value),

      }));

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | SUBDOMAIN
    |--------------------------------------------------------------------------
    */

    if (
      name === "subdomain"
    ) {

      setSubdomainManuallyEdited(
        true
      );


      setForm((previous) => ({

        ...previous,

        subdomain:
          generateSubdomain(value),

      }));

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | BUSINESS CODE
    |--------------------------------------------------------------------------
    */

    if (
      name === "businessCode"
    ) {

      setForm((previous) => ({

        ...previous,

        businessCode:
          generateBusinessCode(value),

      }));

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | CUSTOM DOMAIN
    |--------------------------------------------------------------------------
    |
    | User can type:
    |
    | https://www.abccomputers.com
    |
    | We store:
    |
    | abccomputers.com
    |
    |--------------------------------------------------------------------------
    */

    if (
      name === "customDomain"
    ) {

      const normalized =
        value
          .toLowerCase()
          .replace(/^https?:\/\//, "")
          .replace(/^www\./, "")
          .replace(/\s/g, "");


      setForm((previous) => ({

        ...previous,

        customDomain:
          normalized,

      }));

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | NORMAL FIELD
    |--------------------------------------------------------------------------
    */

    setForm((previous) => ({

      ...previous,

      [name]:
        value,

    }));

  };


  /*
  |--------------------------------------------------------------------------
  | COPY BUSINESS MOBILE TO OWNER
  |--------------------------------------------------------------------------
  */

  const useBusinessMobileForOwner = () => {

    setForm((previous) => ({

      ...previous,

      ownerMobile:
        previous.businessMobile,

    }));

  };


  /*
  |--------------------------------------------------------------------------
  | COPY BUSINESS EMAIL TO OWNER
  |--------------------------------------------------------------------------
  */

  const useBusinessEmailForOwner = () => {

    setForm((previous) => ({

      ...previous,

      ownerEmail:
        previous.businessEmail,

    }));

  };


  /*
  |--------------------------------------------------------------------------
  | VALIDATION
  |--------------------------------------------------------------------------
  */

  const validateForm = () => {


    /*
    |--------------------------------------------------------------------------
    | BUSINESS NAME
    |--------------------------------------------------------------------------
    */

    if (
      !form.businessName.trim()
    ) {

      alert(
        "Please enter your business name."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | BUSINESS CODE
    |--------------------------------------------------------------------------
    */

    if (
      !form.businessCode.trim()
    ) {

      alert(
        "Please enter business code."
      );

      return false;

    }


    if (
      !/^[A-Z0-9]+(?:_[A-Z0-9]+)*$/.test(
        form.businessCode
      )
    ) {

      alert(
        "Business code can contain only letters, numbers and underscores."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | BUSINESS MOBILE
    |--------------------------------------------------------------------------
    */

    if (
      !form.businessMobile
    ) {

      alert(
        "Please enter business mobile number."
      );

      return false;

    }


    if (
      !/^[6-9]\d{9}$/.test(
        form.businessMobile
      )
    ) {

      alert(
        "Please enter a valid 10 digit business mobile number."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | BUSINESS EMAIL
    |--------------------------------------------------------------------------
    */

    if (
      form.businessEmail &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        form.businessEmail
      )
    ) {

      alert(
        "Please enter a valid business email address."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | SUBDOMAIN
    |--------------------------------------------------------------------------
    */

    if (
      !form.subdomain.trim()
    ) {

      alert(
        "Please enter business subdomain."
      );

      return false;

    }


    if (
      !/^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(
        form.subdomain
      )
    ) {

      alert(
        "Please enter a valid business subdomain."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | CUSTOM DOMAIN
    |--------------------------------------------------------------------------
    |
    | Optional.
    |
    |--------------------------------------------------------------------------
    */

    if (
      form.customDomain &&
      !/^(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z]{2,}$/i.test(
        form.customDomain
      )
    ) {

      alert(
        "Please enter a valid custom domain, for example abccomputers.com."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | OWNER NAME
    |--------------------------------------------------------------------------
    */

    if (
      !form.ownerName.trim()
    ) {

      alert(
        "Please enter owner name."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | OWNER MOBILE
    |--------------------------------------------------------------------------
    */

    if (
      !form.ownerMobile
    ) {

      alert(
        "Please enter owner mobile number."
      );

      return false;

    }


    if (
      !/^[6-9]\d{9}$/.test(
        form.ownerMobile
      )
    ) {

      alert(
        "Please enter a valid 10 digit owner mobile number."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | OWNER EMAIL
    |--------------------------------------------------------------------------
    */

    if (
      form.ownerEmail &&
      !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        form.ownerEmail
      )
    ) {

      alert(
        "Please enter a valid owner email address."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | PASSWORD
    |--------------------------------------------------------------------------
    |
    | Backend requires minimum 8 characters.
    |
    |--------------------------------------------------------------------------
    */

    if (
      !form.password
    ) {

      alert(
        "Please enter password."
      );

      return false;

    }


    if (
      form.password.length < 8
    ) {

      alert(
        "Password should be at least 8 characters."
      );

      return false;

    }


    /*
    |--------------------------------------------------------------------------
    | CONFIRM PASSWORD
    |--------------------------------------------------------------------------
    */

    if (
      !form.confirmPassword
    ) {

      alert(
        "Please confirm your password."
      );

      return false;

    }


    if (
      form.password !==
      form.confirmPassword
    ) {

      alert(
        "Password and confirm password do not match."
      );

      return false;

    }


    return true;

  };


  /*
  |--------------------------------------------------------------------------
  | SIGNUP
  |--------------------------------------------------------------------------
  */

  const handleSignup = async (event) => {

    event.preventDefault();


    /*
    |--------------------------------------------------------------------------
    | PREVENT DOUBLE SUBMIT
    |--------------------------------------------------------------------------
    */

    if (
      loading
    ) {

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | VALIDATE
    |--------------------------------------------------------------------------
    */

    if (
      !validateForm()
    ) {

      return;

    }


    /*
    |--------------------------------------------------------------------------
    | REQUEST PAYLOAD
    |--------------------------------------------------------------------------
    */

    const payload = {

      business: {


        /*
        |--------------------------------------------------------------------------
        | BUSINESS
        |--------------------------------------------------------------------------
        */

        name:
          form.businessName.trim(),

        legalName:
          form.businessName.trim(),


        /*
        |--------------------------------------------------------------------------
        | BUSINESS CODE
        |--------------------------------------------------------------------------
        |
        | Empty because backend generates Business Code.
        |
        |--------------------------------------------------------------------------
        */

        code:
          form.businessCode.trim().toUpperCase(),


        /*
        |--------------------------------------------------------------------------
        | DOMAIN
        |--------------------------------------------------------------------------
        */

        subdomain:
          form.subdomain.trim(),

        customDomain:
          form.customDomain.trim() ||
          "",


        /*
        |--------------------------------------------------------------------------
        | CONTACT
        |--------------------------------------------------------------------------
        */

        mobile:
          form.businessMobile.trim(),

        email:
          form.businessEmail
            .trim()
            .toLowerCase(),


        /*
        |--------------------------------------------------------------------------
        | TAX
        |--------------------------------------------------------------------------
        */

        gstNumber:
          "",

        panNumber:
          "",


        /*
        |--------------------------------------------------------------------------
        | ADDRESS
        |--------------------------------------------------------------------------
        */

        address: {

          line1:
            "",

          line2:
            "",

          city:
            "",

          state:
            "",

          pincode:
            "",

          country:
            "India",

        },


        /*
        |--------------------------------------------------------------------------
        | SUBSCRIPTION
        |--------------------------------------------------------------------------
        |
        | Registration starts with Trial.
        |
        |--------------------------------------------------------------------------
        */

        subscriptionStatus:
          "TRIAL",

        trialEndsAt:
          null,


        /*
        |--------------------------------------------------------------------------
        | FEATURES
        |--------------------------------------------------------------------------
        */

        storefrontEnabled:
          false,

        marketplaceEnabled:
          false,


        /*
        |--------------------------------------------------------------------------
        | BRANDING
        |--------------------------------------------------------------------------
        */

        branding: {

          logo:
            "",

          favicon:
            "",

          primaryColor:
            "",

          secondaryColor:
            "",

        },

      },


      /*
      |--------------------------------------------------------------------------
      | OWNER
      |--------------------------------------------------------------------------
      */

      owner: {

        name:
          form.ownerName.trim(),

        mobile:
          form.ownerMobile.trim(),

        email:
          form.ownerEmail
            .trim()
            .toLowerCase(),

        password:
          form.password,

      },

    };


    /*
    |--------------------------------------------------------------------------
    | REFERRAL
    |--------------------------------------------------------------------------
    */

    if (
      form.referral.trim()
    ) {

      payload.referralCode =
        form.referral.trim();

    }


    try {

      setLoading(
        true
      );


      /*
      |--------------------------------------------------------------------------
      | REGISTER TENANT
      |--------------------------------------------------------------------------
      */

      const response =
        await api.post(
          config.tenantRegister,
          payload
        );


      /*
      |--------------------------------------------------------------------------
      | SUCCESS
      |--------------------------------------------------------------------------
      */

      if (
        response?.success === true
      ) {


        /*
        |--------------------------------------------------------------------------
        | CREATED TENANT
        |--------------------------------------------------------------------------
        */

        const tenant =
          response?.data?.tenant ||
          response?.data?.business ||
          null;


        /*
        |--------------------------------------------------------------------------
        | BUSINESS CODE
        |--------------------------------------------------------------------------
        */

        const businessCode =
          tenant?.code ||
          response?.data?.code ||
          "";


        /*
        |--------------------------------------------------------------------------
        | SUBDOMAIN
        |--------------------------------------------------------------------------
        */

        const createdSubdomain =
          tenant?.subdomain ||
          form.subdomain;


        /*
        |--------------------------------------------------------------------------
        | DOMAIN
        |--------------------------------------------------------------------------
        */

        const platformDomain =
          response?.data?.domain?.hostname ||
          (
            createdSubdomain
              ? `${createdSubdomain}.comkwik.com`
              : ""
          );


        /*
        |--------------------------------------------------------------------------
        | SAVE BUSINESS CODE
        |--------------------------------------------------------------------------
        */

        if (
          businessCode
        ) {

          try {

            window.localStorage.setItem(
              "comkwik_admin_business_code",
              String(
                businessCode
              )
                .trim()
                .toUpperCase()
            );

          } catch (error) {

            console.warn(
              "Unable to save business code:",
              error
            );

          }

        }


        /*
        |--------------------------------------------------------------------------
        | SUCCESS MESSAGE
        |--------------------------------------------------------------------------
        */

        let successMessage =
          "Business Account Created Successfully!";


        if (
          businessCode
        ) {

          successMessage +=
            `\n\nBusiness Code: ${businessCode}`;

        }


        if (
          platformDomain
        ) {

          successMessage +=
            `\nStore URL: ${platformDomain}`;

        }


        successMessage +=
          "\n\nPlease save your Business Code. You will need it to login.";


        alert(
          successMessage
        );


        /*
        |--------------------------------------------------------------------------
        | LOGIN PAGE
        |--------------------------------------------------------------------------
        */

        history.replace(
          "/"
        );


        return;

      }


      /*
      |--------------------------------------------------------------------------
      | FAILED RESPONSE
      |--------------------------------------------------------------------------
      */

      alert(
        response?.message ||
        "Unable to create business account."
      );


    } catch (error) {

      console.error(
        "Tenant registration error:",
        error
      );


      const message =
        error?.response?.data?.message ||
        error?.message ||
        "Unable to create business account.";


      alert(
        message
      );


    } finally {

      setLoading(
        false
      );

    }

  };


  /*
  |--------------------------------------------------------------------------
  | LOGIN
  |--------------------------------------------------------------------------
  */

  const goToLogin = () => {

    history.push(
      "/"
    );

  };


  /*
  |--------------------------------------------------------------------------
  | UI
  |--------------------------------------------------------------------------
  */

  return (

    <div className="signup-page">


      {/* Background */}

      <div
        className="signup-background-shape signup-shape-one"
      />

      <div
        className="signup-background-shape signup-shape-two"
      />


      <div className="signup-container">


        {/* ========================================================== */}
        {/* LEFT SIDE */}
        {/* ========================================================== */}

        <div className="signup-left">


          {/* Logo */}

          <div className="signup-brand">

            <img
              src={logo}
              alt="ComKwik"
              className="signup-brand-logo"
            />

          </div>


          {/* Content */}

          <div className="signup-left-content">

            <span className="signup-badge">
              Business Management Made Simple
            </span>


            <h1>

              Start managing your

              <span>
                {" "}
                business smarter.
              </span>

            </h1>


            <p>

              Create your ComKwik business account and manage
              customers, inventory, billing, orders, employees
              and more from one place.

            </p>


            {/* Benefits */}

            <div className="signup-benefits">


              {/* Benefit 1 */}

              <div className="signup-benefit">

                <span className="signup-benefit-icon">

                  <FiCheck />

                </span>

                <div>

                  <strong>
                    Quick Setup
                  </strong>

                  <small>
                    Create your business account in minutes.
                  </small>

                </div>

              </div>


              {/* Benefit 2 */}

              <div className="signup-benefit">

                <span className="signup-benefit-icon">

                  <FiCheck />

                </span>

                <div>

                  <strong>
                    Your Own Store URL
                  </strong>

                  <small>
                    Get your own ComKwik business subdomain.
                  </small>

                </div>

              </div>


              {/* Benefit 3 */}

              <div className="signup-benefit">

                <span className="signup-benefit-icon">

                  <FiCheck />

                </span>

                <div>

                  <strong>
                    Everything in One Place
                  </strong>

                  <small>
                    Manage your daily business operations easily.
                  </small>

                </div>

              </div>


              {/* Benefit 4 */}

              <div className="signup-benefit">

                <span className="signup-benefit-icon">

                  <FiCheck />

                </span>

                <div>

                  <strong>
                    Start With Trial
                  </strong>

                  <small>
                    Explore ComKwik before choosing your paid plan.
                  </small>

                </div>

              </div>

            </div>

          </div>


          {/* Footer */}

          <div className="signup-left-footer">

            <span>
              ComKwik
            </span>

            <span>
              Good Devices. Better Possibilities.
            </span>

          </div>

        </div>


        {/* ========================================================== */}
        {/* RIGHT SIDE */}
        {/* ========================================================== */}

        <div className="signup-right">


          {/* Mobile Logo */}

          <div className="signup-mobile-logo">

            <img
              src={logo}
              alt="ComKwik"
            />

          </div>


          <div className="signup-form-wrapper">


            {/* ====================================================== */}
            {/* HEADER */}
            {/* ====================================================== */}

            <div className="signup-header">

              <h2>
                Create Business Account
              </h2>

              <p>
                Enter your business and owner information to get started.
              </p>

            </div>


            {/* ====================================================== */}
            {/* STEPPER */}
            {/* ====================================================== */}

            <div className="signup-stepper">


              <div className="signup-step active">

                <span>
                  1
                </span>

                <small>
                  Business
                </small>

              </div>


              <div className="signup-step-line active" />


              <div className="signup-step active">

                <span>
                  2
                </span>

                <small>
                  Owner
                </small>

              </div>


              <div className="signup-step-line" />


              <div className="signup-step">

                <span>
                  3
                </span>

                <small>
                  Finish
                </small>

              </div>


            </div>


            {/* ====================================================== */}
            {/* FORM */}
            {/* ====================================================== */}

            <form
              className="signup-form"
              onSubmit={handleSignup}
            >


              {/* ==================================================== */}
              {/* BUSINESS INFORMATION */}
              {/* ==================================================== */}

              <div className="signup-section">


                {/* Heading */}

                <div className="signup-section-title">

                  <span className="signup-section-icon">

                    <FiBriefcase />

                  </span>

                  <div>

                    <h3>
                      Business Information
                    </h3>

                    <p>
                      Tell us about your business.
                    </p>

                  </div>

                </div>


                {/* Business Name */}

                <div className="signup-field">

                  <label>

                    Business Name

                    <span>
                      *
                    </span>

                  </label>

                  <div className="signup-input">

                    <FiBriefcase />

                    <input
                      type="text"
                      name="businessName"
                      value={form.businessName}
                      onChange={handleChange}
                      placeholder="Enter business name"
                      autoComplete="organization"
                    />

                  </div>

                </div>


                {/* Business Code */}

                <div className="signup-field">

                  <label>
                    Business Code
                    <span>
                      *
                    </span>
                  </label>

                  <div className="signup-input">

                    <FiBriefcase />

                    <input
                      type="text"
                      name="businessCode"
                      value={form.businessCode}
                      onChange={handleChange}
                      placeholder="BUSINESS_CODE"
                      autoComplete="off"
                    />

                  </div>

                  <p className="signup-field-help">
                    Automatically generated from Business Name. You can edit it before creating the account.
                  </p>

                </div>


                {/* Business Contact */}

                <div className="signup-grid">


                  {/* Mobile */}

                  <div className="signup-field">

                    <label>

                      Business Mobile

                      <span>
                        *
                      </span>

                    </label>

                    <div className="signup-input">

                      <FiPhone />

                      <input
                        type="tel"
                        name="businessMobile"
                        value={form.businessMobile}
                        onChange={handleChange}
                        placeholder="10 digit mobile"
                        maxLength={10}
                        inputMode="numeric"
                        autoComplete="tel"
                      />

                    </div>

                  </div>


                  {/* Email */}

                  <div className="signup-field">

                    <label>
                      Business Email
                    </label>

                    <div className="signup-input">

                      <FiMail />

                      <input
                        type="email"
                        name="businessEmail"
                        value={form.businessEmail}
                        onChange={handleChange}
                        placeholder="business@example.com"
                        autoComplete="email"
                      />

                    </div>

                  </div>


                </div>


                {/* ================================================== */}
                {/* BUSINESS DOMAIN */}
                {/* ================================================== */}

                <div className="signup-domain-box">


                  {/* Domain Heading */}

                  <div className="signup-domain-heading">

                    <FiGlobe />

                    <div>

                      <strong>
                        Business Domain
                      </strong>

                      <small>
                        Configure how customers can access your online store.
                      </small>

                    </div>

                  </div>


                  {/* ================================================ */}
                  {/* SUBDOMAIN */}
                  {/* ================================================ */}

                  <div className="signup-field">

                    <label>

                      ComKwik Subdomain

                      <span>
                        *
                      </span>

                    </label>


                    <div className="signup-domain-input">


                      <div className="signup-input">

                        <FiLink />

                        <input
                          type="text"
                          name="subdomain"
                          value={form.subdomain}
                          onChange={handleChange}
                          placeholder="your-business"
                          autoComplete="off"
                        />

                      </div>


                      <span className="signup-domain-suffix">
                        .comkwik.com
                      </span>


                    </div>


                    {/* Preview */}

                    {
                      form.subdomain && (

                        <div className="signup-domain-preview">

                          <FiGlobe />

                          <span>
                            Your store:
                          </span>

                          <strong>
                            {form.subdomain}.comkwik.com
                          </strong>

                        </div>

                      )
                    }


                  </div>


                  {/* ================================================ */}
                  {/* CUSTOM DOMAIN */}
                  {/* ================================================ */}

                  <div className="signup-field">

                    <label>

                      Custom Domain

                      <small className="signup-optional">
                        Optional
                      </small>

                    </label>


                    <div className="signup-input">

                      <FiGlobe />

                      <input
                        type="text"
                        name="customDomain"
                        value={form.customDomain}
                        onChange={handleChange}
                        placeholder="example.com"
                        autoComplete="off"
                      />

                    </div>


                    <p className="signup-field-help">

                      Already own a domain? Enter it here.
                      You can also configure your custom domain later.

                    </p>


                  </div>


                </div>


              </div>


              {/* ==================================================== */}
              {/* OWNER INFORMATION */}
              {/* ==================================================== */}

              <div className="signup-section">


                {/* Heading */}

                <div className="signup-section-title">

                  <span className="signup-section-icon">

                    <FiUser />

                  </span>

                  <div>

                    <h3>
                      Owner Information
                    </h3>

                    <p>
                      This will be your main administrator account.
                    </p>

                  </div>

                </div>


                {/* Owner Name */}

                <div className="signup-field">

                  <label>

                    Owner Name

                    <span>
                      *
                    </span>

                  </label>

                  <div className="signup-input">

                    <FiUser />

                    <input
                      type="text"
                      name="ownerName"
                      value={form.ownerName}
                      onChange={handleChange}
                      placeholder="Enter owner name"
                      autoComplete="name"
                    />

                  </div>

                </div>


                {/* Owner Contact */}

                <div className="signup-grid">


                  {/* Owner Mobile */}

                  <div className="signup-field">


                    <div className="signup-label-row">

                      <label>

                        Owner Mobile

                        <span>
                          *
                        </span>

                      </label>


                      {
                        form.businessMobile &&
                        form.ownerMobile !==
                          form.businessMobile && (

                          <button
                            type="button"
                            className="signup-copy-btn"
                            onClick={
                              useBusinessMobileForOwner
                            }
                          >
                            Same as business
                          </button>

                        )
                      }

                    </div>


                    <div className="signup-input">

                      <FiPhone />

                      <input
                        type="tel"
                        name="ownerMobile"
                        value={form.ownerMobile}
                        onChange={handleChange}
                        placeholder="10 digit mobile"
                        maxLength={10}
                        inputMode="numeric"
                        autoComplete="tel"
                      />

                    </div>


                  </div>


                  {/* Owner Email */}

                  <div className="signup-field">


                    <div className="signup-label-row">

                      <label>
                        Owner Email
                      </label>


                      {
                        form.businessEmail &&
                        form.ownerEmail !==
                          form.businessEmail && (

                          <button
                            type="button"
                            className="signup-copy-btn"
                            onClick={
                              useBusinessEmailForOwner
                            }
                          >
                            Same as business
                          </button>

                        )
                      }

                    </div>


                    <div className="signup-input">

                      <FiMail />

                      <input
                        type="email"
                        name="ownerEmail"
                        value={form.ownerEmail}
                        onChange={handleChange}
                        placeholder="owner@example.com"
                        autoComplete="email"
                      />

                    </div>


                  </div>


                </div>


                {/* Password */}

                <div className="signup-grid">


                  {/* Password */}

                  <div className="signup-field">

                    <label>

                      Password

                      <span>
                        *
                      </span>

                    </label>


                    <div className="signup-input">

                      <FiLock />

                      <input
                        type={
                          showPassword
                            ? "text"
                            : "password"
                        }
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        placeholder="Minimum 8 characters"
                        autoComplete="new-password"
                      />


                      <button
                        type="button"
                        className="signup-eye"
                        onClick={() =>
                          setShowPassword(
                            (previous) =>
                              !previous
                          )
                        }
                        aria-label={
                          showPassword
                            ? "Hide password"
                            : "Show password"
                        }
                      >

                        {
                          showPassword
                            ? <FiEye />
                            : <FiEyeOff />
                        }

                      </button>


                    </div>

                  </div>


                  {/* Confirm Password */}

                  <div className="signup-field">

                    <label>

                      Confirm Password

                      <span>
                        *
                      </span>

                    </label>


                    <div className="signup-input">

                      <FiLock />

                      <input
                        type={
                          showConfirmPassword
                            ? "text"
                            : "password"
                        }
                        name="confirmPassword"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        placeholder="Re-enter password"
                        autoComplete="new-password"
                      />


                      <button
                        type="button"
                        className="signup-eye"
                        onClick={() =>
                          setShowConfirmPassword(
                            (previous) =>
                              !previous
                          )
                        }
                        aria-label={
                          showConfirmPassword
                            ? "Hide confirm password"
                            : "Show confirm password"
                        }
                      >

                        {
                          showConfirmPassword
                            ? <FiEye />
                            : <FiEyeOff />
                        }

                      </button>


                    </div>

                  </div>


                </div>


              </div>


              {/* ==================================================== */}
              {/* REFERRAL */}
              {/* ==================================================== */}

              <div className="signup-referral">


                <div className="signup-referral-heading">

                  <FiGift />

                  <div>

                    <strong>
                      Have a referral code?
                    </strong>

                    <small>
                      Enter it below if someone invited you.
                    </small>

                  </div>

                </div>


                <div className="signup-input">

                  <FiGift />

                  <input
                    type="text"
                    name="referral"
                    value={form.referral}
                    onChange={handleChange}
                    placeholder="Referral Code (Optional)"
                    autoComplete="off"
                  />

                </div>


              </div>


              {/* ==================================================== */}
              {/* SUBMIT */}
              {/* ==================================================== */}

              <button
                type="submit"
                className="signup-submit"
                disabled={loading}
              >

                {
                  loading
                    ? (
                      <>

                        <span className="signup-spinner" />

                        Creating Business...

                      </>
                    )
                    : (
                      <>
                        Create Business Account
                      </>
                    )
                }

              </button>


              {/* ==================================================== */}
              {/* LOGIN */}
              {/* ==================================================== */}

              <div className="signup-login-row">

                <span>
                  Already have a business account?
                </span>

                <button
                  type="button"
                  onClick={goToLogin}
                  disabled={loading}
                >
                  Login
                </button>

              </div>


              {/* ==================================================== */}
              {/* TERMS */}
              {/* ==================================================== */}

              <p className="signup-terms">

                By creating an account, you agree to our

                <button
                  type="button"
                >
                  Terms & Conditions
                </button>

                and

                <button
                  type="button"
                >
                  Privacy Policy
                </button>.

              </p>


            </form>


          </div>

        </div>


      </div>

    </div>

  );

};


export default Signup;